
<div class="dialog">
<div mat-dialog-title>Create a new security
</div>
<mat-dialog-content>
   <div>CREATE NEW SECURITY CONTENT</div>
</mat-dialog-content>
<mat-dialog-actions>
    <button id="closeButton" (click)="closeDialog()" class="btn-medium-secondary">Cancel</button>
</mat-dialog-actions>
</div>

